/**
 * Definiert das Model für die Auswertung der Eingaben bei der Input-Aufgabe
 * @class service_v3sInputElement
 * @memberOf v3sWbtPlayerApp:exercise:input
 */
angular.module('v3sWbtPlayerApp').factory('v3sInputElement', ["v3sExerciseElement", "v3sStringService", "v3sI18nService", function (v3sExerciseElement, v3sStringService, v3sI18nService) {

   /**
   * Konstruktor
   * @memberOf v3sWbtPlayerApp:exercise:input.service_v3sInputElement
   */
    var v3sInputElement = function (id) {
        this.id = id;
        this.userAnswer = "";
        this.correctAnswers = [];
        this.type = "";
        this.load();
    };

    v3sInputElement.prototype = new v3sExerciseElement();

   /**
   * Legt die Genauigkeit bei der Auswertung fest
   * @memberOf v3sWbtPlayerApp:exercise:input.service_v3sInputElement
   * @param {number} tolerance - Genauigkeit, von 0% bis 100%
   */
    v3sInputElement.prototype.setTolerance = function (tolerance) {
        this.tolerance = tolerance;
    }

    /**
   * Setzt den Typ fest
   * @memberOf v3sWbtPlayerApp:exercise:input.service_v3sInputElement
   * @param {string} type - Typ (number/text)
   */
    v3sInputElement.prototype.setType = function (type) {
        this.type = type;
    }

    /**
   * Fügt eine korrekte Antwort hinzu
   * @memberOf v3sWbtPlayerApp:exercise:input.service_v3sInputElement
   * @param {string} answer - korrekte Antwort
   */
    v3sInputElement.prototype.addCorrectAnswer = function (answer) {
        var answer = answer.trim(answer);
        this.correctAnswers.push(answer.toLowerCase());
    };

   /**
   * Aktualisiert und wertet die Benutzer-Antwort aus. <br>
   * @memberOf v3sWbtPlayerApp:exercise:input.service_v3sInputElement
   * @param {string} answer - Benutzer-Antwort
   */
    v3sInputElement.prototype.setUserAnswer = function (answer) {
        if (answer != this.userAnswer) {
            this.userAnswer = answer;
            this.status = this.STATUS.NO_ANSWER;

            var self = this;
            if (!!self.userAnswer) {
                var parsedAnswer;
                if (self.type === 'number') {
                    if (!angular.isNumber(self.userAnswer)) {
                        parsedAnswer = v3sI18nService.parseFloat(self.userAnswer);
                    }
                } else {
                    parsedAnswer = self.userAnswer.toLowerCase();
                }
                angular.forEach(self.correctAnswers, function (correct) {
                    if (self.status != self.STATUS.CORRECT) {//Korrekt antwort noch nicht gefunden
                        var parsedCorrAnswer,
                            answerIsCorrect;
                        if (self.type === 'number') {
                            parsedCorrAnswer = v3sI18nService.parseFloat(correct);
                            answerIsCorrect = (parsedCorrAnswer === parsedAnswer);
                        } else {// Type === 'text'
                            answerIsCorrect = v3sStringService.equalsWithTolerance(parsedAnswer, correct, self.tolerance);
                        }

                        if (answerIsCorrect) {
                            self.status = self.STATUS.CORRECT;
                        } else {
                            self.status = self.STATUS.FALSE;
                        }
                    }
                });

                self.save();
            } else {
                self.status = self.STATUS.NO_ANSWER;
            }
        }

    };

    return v3sInputElement;
}]);